 import {ajax} from 'src/commons/ajax';
/*
* 菜单数据 返回Promise各式，支持前端硬编码、异步获取菜单数据
* */
export default function getMenus(userId) {
    //console.log(userId);
    return ajax.get('/api/module/getModulesByUserId', {userId}, {'Content-Type': 'application/json'}).then(res => {
        console.log("menu.rows",res.rows);
        return (res.rows || []).map(item => ({key: item.key, parentKey: item.parentKey,text:item.text,path:item.path,target:'',icon:item.icon,order:item.order,link:item.link}));
    });
}


 // return Promise.resolve([
 //     {key: 'my-key', text: '我的测试页面', icon: 'user', path: '/my-test'},
 //
 //     {key: 'antDesign', text: 'Ant Design 官网', icon: 'ant-design', url: 'https://ant-design.gitee.io', target: '', order: 2000},
 //     {key: 'document', text: '文档', icon: 'book', url: 'https://sxfad.github.io/react-admin/#/', target: '_blank', order: 1200},
 //
 // ]);

/*
菜单数据主键也可以是：id parentId
角色字段： id name description
* */
